var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "open-salud-about" },
    [
      _c(
        "v-row",
        { staticClass: "row container-assistance" },
        [
          _c(
            "v-col",
            {
              staticClass: "main-container-text px-lg-16 my-auto",
              attrs: { sm: "6" }
            },
            [
              _c("h3", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "pl-0", attrs: { sm: "12" } },
                [
                  _c(
                    "v-list",
                    { staticClass: "mt-8 icons-listed" },
                    [
                      _c(
                        "v-list-item-group",
                        { attrs: { "aria-label": _vm.title } },
                        _vm._l(
                          _vm.$uiHelpers.isMobile
                            ? _vm.items.slice(0, 3)
                            : _vm.items,
                          function(ref, index) {
                            var text = ref.text
                            var path = ref.path
                            return _c(
                              "v-list-item",
                              {
                                key: index,
                                attrs: { "aria-label": text },
                                on: {
                                  click: function($event) {
                                    return _vm.$helpers.goToSection(path)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-item-icon",
                                  [_c("rounded-check-icon")],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", {
                                      attrs: { "aria-labelledby": text },
                                      domProps: { innerHTML: _vm._s(text) }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "mt-3 button-floating" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "ml-4 btn1",
                          attrs: { white: "", shadow: "" },
                          on: {
                            click: function($event) {
                              return _vm.$helpers.goToSection("pricing-prime")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.button_text) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-col", {
            staticClass: "col-img d-flex flex-row justify-center col-image",
            attrs: { sm: "6" }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$store.getters["session/isLogged"]
        ? _c(
            "div",
            {
              staticClass: "learn-more",
              on: {
                click: function($event) {
                  return _vm.$helpers.goToSection("contact-form")
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("learn-more-btn")))])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54fb96e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54fb96e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/OpensaludpassMainBlock.vue
// module id = 4149
// module chunks = 35